/**
 * Color tokens for remediation request statuses, urgency, and severity.
 * Centralised so the chip, badge, drawer, and table all stay in sync.
 *
 * Urgency rank values come from UI_INTEGRATION_GUIDE.md §Listing endpoint.
 */

export const STATUS_META = {
  NEEDS_INPUTS: {
    label: "Needs inputs",
    bg: "#ffebee",
    fg: "#c62828",
    urgency: 100,
    description: "User must supply additional inputs.",
  },
  PERMS_DENIED: {
    label: "Perms denied",
    bg: "#ffebee",
    fg: "#b71c1c",
    urgency: 90,
    description: "User must fix IAM grants.",
  },
  DRY_RUN_READY: {
    label: "Dry-run ready",
    bg: "#fff3e0",
    fg: "#e65100",
    urgency: 80,
    description: "Awaiting user approval.",
  },
  PRECHECK_FAILED: {
    label: "Precheck failed",
    bg: "#fff9c4",
    fg: "#f57f17",
    urgency: 70,
    description: "Transient — retry via Refresh.",
  },
  PRECHECK_RUNNING: {
    label: "Prechecking",
    bg: "#e3f2fd",
    fg: "#1565c0",
    urgency: 60,
    description: "Active processing.",
  },
  APPROVED: {
    label: "Approved",
    bg: "#e8f5e9",
    fg: "#2e7d32",
    urgency: 50,
    description: "Scheduled, watching.",
  },
  RUNNING: {
    label: "Running",
    bg: "#e3f2fd",
    fg: "#1976d2",
    urgency: 40,
    description: "Execution in-flight.",
  },
  SUCCEEDED: {
    label: "Succeeded",
    bg: "#e8f5e9",
    fg: "#388e3c",
    urgency: 0,
    description: "Completed successfully.",
  },
  FAILED: {
    label: "Failed",
    bg: "#fce4ec",
    fg: "#c2185b",
    urgency: 0,
    description: "Execution failed.",
  },
  CANCELLED: {
    label: "Cancelled",
    bg: "#eeeeee",
    fg: "#616161",
    urgency: 0,
    description: "Cancelled by user.",
  },
  SKIPPED: {
    label: "Skipped",
    bg: "#eeeeee",
    fg: "#616161",
    urgency: 0,
    description: "Skipped.",
  },
};

export const SEVERITY_META = {
  CRITICAL: { bg: "#ffebee", fg: "#b71c1c" },
  HIGH: { bg: "#ffebee", fg: "#f44336" },
  MEDIUM: { bg: "#fff9c4", fg: "#fbc02d" },
  LOW: { bg: "#e8f5e9", fg: "#4caf50" },
  INFORMATIONAL: { bg: "#e3f2fd", fg: "#1976d2" },
};

export const TERMINAL_STATUSES = new Set([
  "SUCCEEDED",
  "FAILED",
  "CANCELLED",
  "SKIPPED",
]);

export const ATTENTION_NEEDED_STATUSES = [
  "NEEDS_INPUTS",
  "PERMS_DENIED",
  "DRY_RUN_READY",
  "PRECHECK_FAILED",
];

export const ACTIVE_STATUSES = ["PRECHECK_RUNNING", "RUNNING", "APPROVED"];

export const ALL_STATUSES = [
  ...ATTENTION_NEEDED_STATUSES,
  ...ACTIVE_STATUSES,
  "SUCCEEDED",
  "FAILED",
  "CANCELLED",
];
